import React from 'react';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'María',
  age: '48 años',
  text: 'Desde que empecé la menopausia me sentía agotada. Con este manual volví a tener energía real y los sofocos disminuyeron notablemente.',
  stars: 5,
  featured: true
}, {
  name: 'Laura',
  age: '44 años',
  text: 'Las recetas son fáciles y riquísimas. Por fin algo pensado para mi etapa y no esas dietas genéricas de siempre.',
  stars: 5
}, {
  name: 'Ana',
  age: '52 años',
  text: 'Los sofocos disminuyeron y duermo mucho mejor. Lo recomiendo totalmente a cualquier mujer que esté pasando por esto.',
  stars: 5
}, {
  name: 'Sofía',
  age: '46 años',
  text: 'Entendí cómo funciona mi cuerpo ahora. Cambié mi alimentación siguiendo el manual y me siento otra persona.',
  stars: 5
}, {
  name: 'Carolina',
  age: '50 años',
  text: 'Mi digestión mejoró muchísimo. Ya no me siento hinchada después de comer y bajé la inflamación abdominal.',
  stars: 5
}];
export function TestimonialsSection() {
  return <section className="py-16 md:py-24 bg-white px-5 border-b border-gray-100" data-id="element-297">
      <div className="max-w-5xl mx-auto" data-id="element-298">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-gray-900 mb-12 md:mb-16 tracking-tight" data-id="element-299">
          💬 Mujeres reales, resultados reales
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-300">
          {/* Featured Testimonial - Full Width on Desktop */}
          <div className="md:col-span-2 bg-gradient-to-br from-emerald-50/50 to-white p-12 rounded-[2.5rem] shadow-lg border border-emerald-100 relative group" data-id="element-301">
            <Quote className="absolute top-10 right-10 w-16 h-16 text-emerald-100 group-hover:text-emerald-200 transition-colors" data-id="element-302" />

            <div className="flex gap-1 mb-8" data-id="element-303">
              {[...Array(5)].map((_, idx) => <Star key={idx} className="w-6 h-6 text-amber-400 fill-current" data-id="element-304" />)}
            </div>

            <p className="text-gray-800 text-2xl md:text-3xl mb-10 italic leading-relaxed font-serif max-w-4xl" data-id="element-305">
              "{testimonials[0].text}"
            </p>

            <div className="flex items-center gap-5" data-id="element-306">
              <div className="w-16 h-16 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-full flex items-center justify-center font-bold text-white text-2xl shadow-md" data-id="element-307">
                {testimonials[0].name.charAt(0)}
              </div>
              <div data-id="element-308">
                <p className="font-bold text-gray-900 text-xl" data-id="element-309">
                  {testimonials[0].name}
                </p>
                <p className="text-emerald-600 font-medium" data-id="element-310">
                  {testimonials[0].age}
                </p>
              </div>
            </div>
          </div>

          {/* Grid of other testimonials */}
          {testimonials.slice(1).map((t, i) => <div key={i} className="bg-white p-10 rounded-[2rem] shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 relative group hover:-translate-y-1" data-id="element-311">
              <Quote className="absolute top-8 right-8 w-10 h-10 text-gray-100 group-hover:text-gray-200 transition-colors" data-id="element-312" />

              <div className="flex gap-1 mb-6" data-id="element-313">
                {[...Array(t.stars)].map((_, idx) => <Star key={idx} className="w-5 h-5 text-amber-400 fill-current" data-id="element-314" />)}
              </div>

              <p className="text-gray-600 text-lg mb-8 italic leading-relaxed font-serif" data-id="element-315">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-316">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center font-bold text-gray-500 text-xl border border-gray-200 group-hover:bg-emerald-50 group-hover:text-emerald-600 group-hover:border-emerald-100 transition-colors" data-id="element-317">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-318">
                  <p className="font-bold text-gray-900 text-lg" data-id="element-319">{t.name}</p>
                  <p className="text-sm text-gray-500 font-medium" data-id="element-320">{t.age}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}